module.exports = __webpack_public_path__ + "img/logo-white.0009879c.png";